import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import API from "../../api"
import {
  Col,
  Input,
  Row,
  Label,
  Form,
  Button,
  Container,
  Card,
  CardBody,
  CardTitle,
  Spinner,
} from "reactstrap"
// Toastify
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { Slide } from "react-toastify"
//i18n
import { withTranslation } from "react-i18next"
import Select from "react-select"

const EditMatiere = props => {
  const [matiere, setMatiere] = useState("")
  const [coeff, setCoeff] = useState("")
  const [credit, setCredit] = useState("")
  const [nbrCours, setNbrCours] = useState("")
  const [nbrTD, setNbrTD] = useState("")
  const [nbrTP, setNbrTP] = useState("")
  const [modalite, setModalite] = useState([
    { value: 1, label: "Régime mixte" },
    { value: 2, label: "Contrôle continu" },
  ])
  const [selectModalite, setSelectModalite] = useState("")
  const [autre, setAutre] = useState("")
  const [departement, setDepartement] = useState([])
  const [selectDepartement, setSelectDepartement] = useState("")
  const [loading, setLoading] = useState(false)
  const [semestre, setSemestre] = useState([
    { value: 1, label: "Semestre 1" },
    { value: 2, label: "Semestre 2" },
  ])
  const [optionAutre, setOptionAutre] = useState([
    { value: 1, label: "Cours Non Intégrée" },
    { value: 2, label: "Cours + TD" },
    { value: 3, label: "Cours + TP" },
  ])
  const [selectSemestre, setSelectSemestre] = useState("")
  const [selectOptionAutre, setSelectOptionAutre] = useState("");
  const [pourcentageCours, setPourcentageCours] = useState("");
  const [pourcentageTd, setPourcentageTd] = useState("");
  const [pourcentageTp, setPourcentageTp] = useState("");
  const [etat, setEtat] = useState("none");
  const [etatCours, setEtatCours] = useState("none");
  const [etatTd, setEtatTd] = useState("none");
  const [etatTp, setEtatTp] = useState("none");
  const [niveau, setNiveau] = useState([]);
  const [selectNiveau, setSelectNiveau] = useState("");
  const [impactData, setImpactData] = useState(null)
  const [loadingVerification, setLoadingVerification] = useState(false)
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var annee_id = userAuthScolarite.user.annee_id
  var user_id = userAuthScolarite.user.id
  useEffect(async () => {
    // Département
    const resD = await API.get("departement/select").then(resD => {
      setDepartement(resD.data.Departement)
    })
    var url = window.location.href
    var array = url.split("=")
    var id = array[1]
    const res = await API.post("matiere/get_by_id", { id ,annee_id}).then(res => {
      setMatiere(res.data.Matiere.name)
      setCoeff(res.data.Matiere.coef)
      setCredit(res.data.Matiere.credit)
      setNbrCours(res.data.Matiere.nbhCours)
      setNbrTD(res.data.Matiere.nbhTD)
      setNbrTP(res.data.Matiere.nbhTP)
      setAutre(res.data.Matiere.autre)
      setSelectModalite(res.data.Matiere.modalite)
      setSelectDepartement(res.data.Matiere.departement_id)
      setSelectNiveau(res.data.Matiere.niveau_id)
      setSelectSemestre(res.data.Matiere.semestre_id)
      setSelectOptionAutre(res.data.Matiere.type_ci)
      setPourcentageCours(res.data.Matiere.pourcentage_cour)
      setPourcentageTd(res.data.Matiere.pourcentage_td)
      setPourcentageTp(res.data.Matiere.pourcentage_tp)
      switch (res.data.Matiere.type_ci.value){
        case 1 :
          setEtatCours("none")
          setEtatTd("none")
          setEtatTp("none")
          break;
        case 2:
          setEtatCours("")
          setEtatTd("")
          setEtatTp("none")
          break;
        case 3 :
          setEtatCours("")
          setEtatTd("none")
          setEtatTp("")
          break ;
      }
      setLoading(true)
    })
  }, [])

  const edit = async () => {
    var url = window.location.href
    var array = url.split("=")
    var id = array[1]
    if (matiere != "" || selectSemestre!="") {
      if(selectOptionAutre.value == 1){
        var type_ci=0
      }else if(selectOptionAutre.value == 2){
        var type_ci=1
      }else{
        var type_ci=2
      }
      // alert(nbrTD ? nbrTD :0)
      const res = await API.post("matiere/update", {
        id: id,
        name: matiere,
        coef: coeff ? coeff : 0,
        credit: credit ? credit : 0,
        nbhCours: nbrCours ? nbrCours : 0,
        nbhTD: nbrTD ? nbrTD : 0,
        nbhTP: nbrTP ? nbrTP : 0,
        autre: autre ? autre : 0,
        type_ci: type_ci,
        modalite_evaluation: selectModalite.label,
        departement_id: selectDepartement.value,
        semestre_id: selectSemestre.value,
        pourcentage_cour: pourcentageCours,
        pourcentage_td: pourcentageTd,
        pourcentage_tp: pourcentageTp,
        user_id,
        annee_id,
        confirmation_requise: true,
      }).then(res => {
        props.history.push("/Matiere")
      })
    } else {
      toast.error("⛔ Nom matière obligatoire", {
        containerId: "A",
      })
    }
  }
  const verifier = async () => {
    var url = window.location.href
    var array = url.split("=")
    var id = array[1]

    if (matiere !== "" && selectSemestre?.value) {
      var type_ci = 2

      if (selectOptionAutre?.value == 1) {
        type_ci = 0
      } else if (selectOptionAutre?.value == 2) {
        type_ci = 1
      }

      setLoadingVerification(true)
      setImpactData(null)

      try {
        const res = await API.post("matiere/preview_update", {
          id: id,
          name: matiere,
          coef: coeff ? coeff : 0,
          credit: credit ? credit : 0,
          nbhCours: nbrCours ? nbrCours : 0,
          nbhTD: nbrTD ? nbrTD : 0,
          nbhTP: nbrTP ? nbrTP : 0,
          autre: autre ? autre : 0,
          type_ci: type_ci,
          modalite_evaluation: selectModalite?.label,
          departement_id: selectDepartement?.value,
          semestre_id: selectSemestre?.value,
          pourcentage_cour: pourcentageCours,
          pourcentage_td: pourcentageTd,
          pourcentage_tp: pourcentageTp,
          user_id,
          annee_id,
        })

        const data = res.data

        if (Number(data.status) === 200) {
          setImpactData(data.impact || null)

          if (data.impact?.changement) {
            toast.warning(
              "Des modifications auront un impact sur les données existantes.",
              { containerId: "A" }
            )
          } else {
            toast.success(data.msg || "Vérification effectuée avec succès.", {
              containerId: "A",
            })
          }
        } else {
          toast.error(data.msg || "Erreur de vérification.", {
            containerId: "A",
          })
        }
      } catch (error) {
        console.error("Erreur preview_update :", error)

        toast.error(
          error.response?.data?.msg || "Erreur lors de la vérification.",
          { containerId: "A" }
        )
      } finally {
        setLoadingVerification(false)
      }
    } else {
      toast.error("⛔ Nom matière et semestre obligatoires", {
        containerId: "A",
      })
    }
  }
  const getPourcentage = async event => {
    setSelectOptionAutre(event)
    switch (event.value){
      case 1 :
        setEtatCours("none")
        setEtatTd("none")
        setEtatTp("none")
        setPourcentageCours("")
        setPourcentageTd("")
        setPourcentageTp("")
        break;
      case 2:
        setEtatCours("")
        setEtatTd("")
        setEtatTp("none")
        setPourcentageCours("")
        setPourcentageTd("")
        setPourcentageTp("")
        break;
      case 3 :
        setEtatCours("")
        setEtatTd("none")
        setEtatTp("")
        setPourcentageCours("")
        setPourcentageTd("")
        setPourcentageTp("")
        break ;
    }

  }
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Card>
            <CardBody>
              {loading ? (
                <Row>
                  <Form>
                    <Row>
                      <Col lg="3">
                        <div className="mb-3">
                          <Label for="basicpill-firstname-input1">
                            Departement :
                          </Label>
                          <Select
                            options={departement}
                            isSearchable={true}
                            value={selectDepartement}
                            onChange={e => setSelectDepartement(e)}
                          />
                        </div>
                      </Col>
                      <Col lg="3">
                        <div className="mb-3">
                          <Label for="basicpill-firstname-input1">
                            Niveau :
                          </Label>
                          <Select
                            options={niveau}
                            isSearchable={true}
                            value={selectNiveau}
                            onChange={e => setSelectNiveau(e)}
                          />
                        </div>
                      </Col>
                      <Col lg="3">
                        <div className="mb-3">
                          <Label for="basicpill-firstname-input1">
                            Semestre
                          </Label>
                          <Select
                            options={semestre}
                            isSearchable={true}
                            value={selectSemestre}
                            onChange={e => setSelectSemestre(e)}
                          />
                        </div>
                      </Col>
                      <Col lg="3">
                        <div className="mb-3">
                          <Label for="basicpill-firstname-input1">
                            Modalité :
                          </Label>
                          <Select
                            options={modalite}
                            isSearchable={true}
                            value={selectModalite}
                            onChange={e => setSelectModalite(e)}
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6">
                        <div className="mb-3">
                          <Label for="basicpill-firstname-input1">
                            Matière :
                          </Label>
                          <Input
                            lg="3"
                            type="text"
                            className="form-control"
                            placeholder="Matiere"
                            value={matiere}
                            onChange={e => setMatiere(e.target.value)}
                          />
                        </div>
                      </Col>

                      <Col lg="3">
                        <div className="mb-3">
                          <Label for="basicpill-firstname-input1">
                            Coeff :
                          </Label>
                          <Input
                            lg="3"
                            type="number"
                            className="form-control"
                            placeholder="Coeff"
                            value={coeff}
                            onChange={e => setCoeff(e.target.value)}
                          />
                        </div>
                      </Col>
                      <Col lg="3">
                        <div className="mb-3">
                          <Label for="basicpill-firstname-input1">
                            Crédit :
                          </Label>
                          <Input
                            lg="3"
                            type="number"
                            className="form-control"
                            placeholder="Crédit"
                            value={credit}
                            onChange={e => setCredit(e.target.value)}
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6">
                        <div className="mb-3">
                          <Label for="basicpill-firstname-input1">
                            Nombre heure cours :
                          </Label>
                          <Input
                            lg="3"
                            type="number"
                            className="form-control"
                            placeholder="Nbr heure cours"
                            value={nbrCours}
                            onChange={e => setNbrCours(e.target.value)}
                          />
                        </div>
                      </Col>
                      <Col lg="6">
                        <div className="mb-3">
                          <Label for="basicpill-firstname-input1">
                            Nombre heure TD :
                          </Label>
                          <Input
                            lg="3"
                            type="number"
                            className="form-control"
                            placeholder="Nbr heure TD"
                            value={nbrTD}
                            onChange={e => setNbrTD(e.target.value)}
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6">
                        <div className="mb-3">
                          <Label for="basicpill-firstname-input1">
                            Nombre heure TP :
                          </Label>
                          <Input
                            lg="3"
                            type="text"
                            className="form-control"
                            placeholder="Nbr heure TP"
                            value={nbrTP}
                            onChange={e => setNbrTP(e.target.value)}
                          />
                        </div>
                      </Col>
                      <Col lg="6">
                        <div className="mb-3">
                          <Label for="basicpill-firstname-input1">
                            Nombre heure autre :
                          </Label>
                          <Input
                            lg="3"
                            type="text"
                            className="form-control"
                            placeholder="Nbr heure autre"
                            value={autre}
                            onChange={e => setAutre(e.target.value)}
                          />
                        </div>
                      </Col>
                    </Row>

                    <Row>
                      <Col lg="6">
                        <div className="mb-3">
                          <Label for="basicpill-firstname-input1">
                            Option Cours Intégrée :
                          </Label>
                          <Select
                            options={optionAutre}
                            isSearchable={true}
                            value={selectOptionAutre}
                            onChange={e => getPourcentage(e)}
                            // onChange={e => setSelectOptionAutre(e)}
                          />
                        </div>
                      </Col>

                      <Col style={{ display: etatCours }} lg="3">
                        <div className="mb-3">
                          <Label for="basicpill-firstname-input1">
                            Nombre heure de cours :
                          </Label>
                          <Input
                            lg="3"
                            type="text"
                            className="form-control"
                            placeholder="Nombre heure de cours"
                            value={pourcentageCours}
                            onChange={e => setPourcentageCours(e.target.value)}
                          />
                        </div>
                      </Col>
                      <Col style={{ display: etatTd }} lg="3">
                        <div className="mb-3">
                          <Label for="basicpill-firstname-input1">
                            Nombre heure de TD :
                          </Label>
                          <Input
                            lg="3"
                            type="text"
                            className="form-control"
                            placeholder="Nombre heure de TD"
                            value={pourcentageTd}
                            onChange={e => setPourcentageTd(e.target.value)}
                          />
                        </div>
                      </Col>
                      <Col style={{ display: etatTp }} lg="3">
                        <div className="mb-3">
                          <Label for="basicpill-firstname-input1">
                            Nombre heure de TP :
                          </Label>
                          <Input
                            lg="3"
                            type="text"
                            className="form-control"
                            placeholder="Nombre heure de TP"
                            value={pourcentageTp}
                            onChange={e => setPourcentageTp(e.target.value)}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Form>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <Col lg="12">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                        }}
                        className="text-center mt-4"
                      >
                        <button
                          type="button"
                          className="btn btn-danger"
                          onClick={verifier}
                          disabled={loadingVerification}
                        >
                          {loadingVerification
                            ? "Vérification en cours..."
                            : "Vérifier l'existence de matière"}
                        </button>
                      </div>
                    </Col>
                  </div>

                  {/* AFFICHAGE AUTOMATIQUE DES RÉSULTATS */}

                  {impactData && (
                    <div className="mt-4">
                      {/* MESSAGE GLOBAL */}

                      <div
                        className={`alert ${
                          impactData.changement
                            ? "alert-warning"
                            : "alert-success"
                        }`}
                      >
                        <strong>Résultat de la vérification :</strong>
                        <div className="mt-2">
                          {impactData.message || "Aucun impact détecté."}
                        </div>
                      </div>

                      {/* INFORMATIONS SUR LE SEMESTRE */}

                      <div className="card mb-4">
                        <div className="card-header bg-primary text-white">
                          <strong>Informations sur le semestre</strong>
                        </div>

                        <div className="card-body">
                          <div className="table-responsive">
                            <table className="table table-bordered table-striped table-hover">
                              <thead className="thead-light">
                                <tr>
                                  <th>Semestre actuel</th>
                                  <th>Nouveau semestre</th>
                                  <th>Changement de semestre</th>
                                </tr>
                              </thead>

                              <tbody>
                                <tr>
                                  <td>
                                    <strong>
                                      {impactData.semestre_avant != null
                                        ? `Semestre ${impactData.semestre_avant}`
                                        : "-"}
                                    </strong>
                                  </td>

                                  <td>
                                    <strong>
                                      {impactData.semestre_apres != null
                                        ? `Semestre ${impactData.semestre_apres}`
                                        : "-"}
                                    </strong>
                                  </td>

                                  <td>
                                    {impactData.changement_semestre === true ? (
                                      <span
                                        className="badge"
                                        style={{
                                          backgroundColor: "#ffc107",
                                          color: "#212529",
                                          fontSize: "12px",
                                          fontWeight: "600",
                                          padding: "6px 12px",
                                          borderRadius: "4px",
                                          display: "inline-block",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        Oui - Semestre modifié
                                      </span>
                                    ) : (
                                      <span
                                        className="badge"
                                        style={{
                                          backgroundColor: "#28a745",
                                          color: "#ffffff",
                                          fontSize: "12px",
                                          fontWeight: "600",
                                          padding: "6px 12px",
                                          borderRadius: "4px",
                                          display: "inline-block",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        Non - Semestre conservé
                                      </span>
                                    )}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>

                          {/* AVERTISSEMENT CHANGEMENT SEMESTRE */}

                          {impactData.changement_semestre === true && (
                            <div className="alert alert-warning mt-3 mb-0">
                              <strong>
                                Attention : changement de semestre !
                              </strong>

                              <div className="mt-2">
                                La matière sera déplacée du{" "}
                                <strong>
                                  Semestre {impactData.semestre_avant}
                                </strong>
                                {" vers le "}
                                <strong>
                                  Semestre {impactData.semestre_apres}
                                </strong>
                                .
                              </div>

                              <div className="mt-2">
                                Veuillez vérifier les séances, les affectations
                                et les fiches de vœux concernées avant de
                                confirmer la modification.
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      {/* TYPES DE MATIÈRE */}

                      <div className="card mb-4">
                        <div className="card-header bg-light">
                          <strong>Types de matière concernés</strong>
                        </div>

                        <div className="card-body">
                          <div className="row">
                            <div className="col-md-6">
                              <strong>Types retirés :</strong>{" "}
                              {impactData.types_retires?.length > 0
                                ? impactData.types_retires.join(", ")
                                : "Aucun"}
                            </div>

                            <div className="col-md-6">
                              <strong>Types ajoutés :</strong>{" "}
                              {impactData.types_ajoutes?.length > 0
                                ? impactData.types_ajoutes.join(", ")
                                : "Aucun"}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* RÉSUMÉ */}

                      <div className="row mb-4">
                        <div className="col-md-4 mb-2">
                          <div className="card text-center border-danger">
                            <div className="card-body">
                              <h6>Séances à supprimer</h6>
                              <h3 className="text-danger">
                                {impactData.resume?.seances_a_supprimer ?? 0}
                              </h3>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-4 mb-2">
                          <div className="card text-center border-warning">
                            <div className="card-body">
                              <h6>Affectations à supprimer</h6>
                              <h3 className="text-warning">
                                {impactData.resume?.affectations_a_supprimer ??
                                  0}
                              </h3>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-4 mb-2">
                          <div className="card text-center border-danger">
                            <div className="card-body">
                              <h6>Fiches de vœux à supprimer</h6>
                              <h3 className="text-danger">
                                {impactData.resume?.voeux_a_supprimer ?? 0}
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* TABLEAU 1 : SÉANCES */}

                      <div className="card mb-4">
                        <div className="card-header bg-danger text-white">
                          <strong>
                            Séances à supprimer (
                            {impactData.a_supprimer?.seances?.length ?? 0})
                          </strong>
                        </div>

                        <div className="card-body">
                          <div className="table-responsive">
                            <table className="table table-bordered table-striped table-hover">
                              <thead className="thead-light">
                                <tr>
                                  <th>#</th>
                                  <th>Enseignant</th>
                                  <th>Type</th>
                                  <th>Groupe</th>
                                  <th>Semestre</th>
                                  <th>Jour</th>
                                  <th>Heure début</th>
                                  <th>Heure fin</th>
                                  <th>Salle</th>
                                  <th>Nb quarts</th>
                                  <th>Quinzaine</th>
                                  <th>Rattrapage</th>
                                </tr>
                              </thead>

                              <tbody>
                                {impactData.a_supprimer?.seances?.length > 0 ? (
                                  impactData.a_supprimer.seances.map(
                                    (item, index) => (
                                      <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{item.enseignant}</td>
                                        <td>{item.libelle_type}</td>
                                        <td>{item.groupe}</td>

                                        <td>
                                          {item.semestre_id != null
                                            ? `Semestre ${item.semestre_id}`
                                            : "-"}
                                        </td>

                                        <td>{item.jour}</td>
                                        <td>{item.quart_debut}</td>
                                        <td>{item.quart_fin}</td>
                                        <td>{item.salle || "-"}</td>
                                        <td>{item.nb_quarts}</td>

                                        <td>
                                          {item.par_quin == 1 ? "Oui" : "Non"}
                                        </td>

                                        <td>
                                          {item.rattrapage == 1 ? "Oui" : "Non"}
                                        </td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td
                                      colSpan="12"
                                      className="text-center text-muted"
                                    >
                                      Aucune séance à supprimer
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>

                      {/* TABLEAU 2 : AFFECTATIONS */}

                      <div className="card mb-4">
                        <div className="card-header bg-warning">
                          <strong>
                            Affectations à supprimer (
                            {impactData.a_supprimer?.affectations?.length ?? 0})
                          </strong>
                        </div>

                        <div className="card-body">
                          <div className="table-responsive">
                            <table className="table table-bordered table-striped table-hover">
                              <thead className="thead-light">
                                <tr>
                                  <th>#</th>
                                  <th>ID affectation</th>
                                  <th>Enseignant</th>
                                  <th>Spécialité</th>
                                  <th>Groupe</th>
                                  <th>Type</th>
                                  <th>Semestre</th>
                                </tr>
                              </thead>

                              <tbody>
                                {impactData.a_supprimer?.affectations?.length >
                                0 ? (
                                  impactData.a_supprimer.affectations.map(
                                    (item, index) => (
                                      <tr key={item.id}>
                                        <td>{index + 1}</td>
                                        <td>{item.id}</td>
                                        <td>{item.enseignant}</td>
                                        <td>{item.specialite}</td>
                                        <td>{item.groupe}</td>
                                        <td>{item.libelle_type}</td>
                                        <td>{item.semestre || "-"}</td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td
                                      colSpan="7"
                                      className="text-center text-muted"
                                    >
                                      Aucune affectation à supprimer
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>

                      {/* TABLEAU 3 : FICHES DE VŒUX */}

                      <div className="card mb-4">
                        <div className="card-header bg-danger text-white">
                          <strong>
                            Fiches de vœux à supprimer (
                            {impactData.a_supprimer?.fiches_voeux_lignes
                              ?.length ?? 0}
                            )
                          </strong>
                        </div>

                        <div className="card-body">
                          <div className="table-responsive">
                            <table className="table table-bordered table-striped table-hover">
                              <thead className="thead-light">
                                <tr>
                                  <th>#</th>
                                  <th>ID ligne</th>
                                  <th>ID fiche</th>
                                  <th>Enseignant</th>
                                  <th>Spécialité</th>
                                  <th>Type</th>
                                  <th>État</th>
                                  <th>Priorité</th>
                                  <th>Nb groupes</th>
                                </tr>
                              </thead>

                              <tbody>
                                {impactData.a_supprimer?.fiches_voeux_lignes
                                  ?.length > 0 ? (
                                  impactData.a_supprimer.fiches_voeux_lignes.map(
                                    (item, index) => (
                                      <tr key={item.id}>
                                        <td>{index + 1}</td>
                                        <td>{item.id}</td>
                                        <td>{item.fiche_voeau_id}</td>
                                        <td>{item.enseignant}</td>
                                        <td>{item.specialite}</td>
                                        <td>{item.libelle_type}</td>

                                        <td>
                                          <span
                                            className="badge"
                                            style={{
                                              backgroundColor:
                                                item.libelle_etat === "Validé"
                                                  ? "#28a745"
                                                  : "#ffc107",
                                              color:
                                                item.libelle_etat === "Validé"
                                                  ? "#ffffff"
                                                  : "#212529",
                                              fontSize: "12px",
                                              fontWeight: "600",
                                              padding: "6px 12px",
                                              borderRadius: "4px",
                                              display: "inline-block",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            {item.libelle_etat || "-"}
                                          </span>
                                        </td>

                                        <td>{item.priorite}</td>
                                        <td>{item.nb_group}</td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td
                                      colSpan="9"
                                      className="text-center text-muted"
                                    >
                                      Aucune fiche de vœux à supprimer
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>

                      {/* CONFIRMATION */}

                      {impactData.confirmation_requise && (
                        <div className="alert alert-danger">
                          <strong>Attention :</strong> La modification de cette
                          matière entraînera la suppression des séances,
                          affectations et fiches de vœux indiquées ci-dessus.
                        </div>
                      )}
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        {" "}
                        <Col lg="6">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                            className="text-center mt-4"
                          >
                            <Button
                              type="button"
                              color="warning"
                              className="btn btn-warning  mb-2 me-2"
                              onClick={() => props.history.push("/Matiere")}
                            >
                              Annuler
                            </Button>
                          </div>
                        </Col>
                        <Col lg="6">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-start",
                            }}
                            className="text-center mt-4"
                          >
                            <button
                              type="button"
                              className="btn btn-primary "
                              onClick={edit}
                            >
                              CONFIRMER
                            </button>
                          </div>
                        </Col>
                      </div>
                    </div>
                  )}
                </Row>
              ) : (
                <div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    {" "}
                    <Spinner type="grow" className="ms-6" color="primary" />
                  </div>
                  <h4
                    style={{ textAlign: "center", marginTop: "2%" }}
                    className="ms-6"
                  >
                    {" "}
                    {"Chargement"} ...{" "}
                  </h4>
                </div>
              )}
            </CardBody>
          </Card>
          <ToastContainer
            transition={Slide}
            enableMultiContainer
            containerId={"A"}
            position={toast.POSITION.TOP_RIGHT}
            autoClose={2500}
          />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withTranslation()(EditMatiere)
EditMatiere.propTypes = {
  history: PropTypes.object,
  t: PropTypes.any,
}
